// Trial context hooks - extracted for Fast Refresh compatibility
import { useContext } from 'react';
import { TrialContext } from '../contexts/TrialProvider';

// Custom hook to use trial context
export const useTrialContext = () => {
  const context = useContext(TrialContext);
  if (!context) {
    throw new Error('useTrialContext must be used within TrialProvider');
  }
  return context;
};

// Backward compatibility wrapper for existing useTrialStatus usage
// This allows gradual migration
export const useTrialStatusCompat = () => {
  const trial = useTrialContext();
  
  return {
    isTrialUser: trial.isTrialUser,
    trialActive: trial.isTrialActive,
    daysRemaining: trial.daysRemaining,
    trialExpired: trial.isTrialExpired,
    loading: trial.loading,
    planType: trial.isPaidUser && trial.state.type === 'paid_user' ? trial.state.planType : null,
  };
};